import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const CandidatesListBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: 'calc(100% - 370px - 24px)', // gap = 24px, menuWidth = 270px
    minHeight: 'calc(100vh - 250px)',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: palette.white,
    borderRadius: '24px',
    padding: '24px', // need to be 32px
    position: 'relative',

    [theme.breakpoints.down('laptop')]: {
      width: '100%',
    },

    [theme.breakpoints.down('tablet')]: {
      minHeight: 'calc(100vh - 136px)',
      width: '100%',
      gap: '4px',
      padding: '8px 0 0 0',
    },
  };
});

export const CandidatesListBlockMainWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '24px',
  };
});

export const CandidatesListBlockHeader = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    marginBottom: '20px',
  };
});

export const CandidatesListBlockTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    marginTop: '8px',
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '120%',
  };
});

export const CandidatesListBlockSortBy = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    minWidth: '260px',

    [theme.breakpoints.down('laptop')]: {
      width: '100%',
    },

    '> p': {
      marginTop: '8px',
      flexShrink: 0,
      color: palette.text.header,
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '128%',
    },
  };
});
